// extracted by mini-css-extract-plugin
module.exports = {"page":"Layout_page__1Dtrb","content":"Layout_content__jiqiX","view":"Layout_view__3eOPv","isSlim":"Layout_isSlim__1qTnT"};